/**
 * RDV en ligne (#429) — per-service online booking config (Q8).
 *
 * Two additive fields on `ServiceDescription`: a duration and an "available
 * online" toggle. FR11 (duration mandatory once enabled) is a CROSS-FIELD Zod
 * check, not a SQL constraint (the column stays nullable — non-enabled services
 * have no duration).
 *
 * Standalone schema: the Epic 1 story merges it into the catalogue payload
 * (`service/payloads.ts`). Kept separate here to keep the contract additive.
 *
 * See `docs/spec/rdv-en-ligne/adr-moteur-et-contrats.md`.
 */
import { z } from "zod";
/**
 * Sanity ceiling on an online slot duration (minutes). NOT a product rule —
 * a guard so an unbounded positive int can't be persisted and then overflow /
 * monopolise the booking engine's slot math. 24h covers any realistic RDV;
 * tighten later if the product defines a real maximum.
 */
export const MAX_ONLINE_DURATION_MINUTES = 24 * 60;
/**
 * FR11 user-facing message — single source reused by the standalone config
 * schema and by the ServiceDescription catalogue payloads (`service/payloads.ts`).
 */
export const RDV_ONLINE_DURATION_REQUIRED_MESSAGE = "Une durée est obligatoire pour une prestation activée à la prise de RDV en ligne";
/**
 * FR11 cross-field check: a prestation exposed online MUST carry a positive
 * duration. Shared `superRefine` body so both the standalone config schema
 * and the catalogue Create/Update payloads enforce it identically.
 */
export function refineRdvOnlineDuration(value, ctx) {
    if (value.onlineBookingEnabled && (value.onlineDurationMinutes ?? 0) <= 0) {
        ctx.addIssue({
            code: z.ZodIssueCode.custom,
            path: ["onlineDurationMinutes"],
            message: RDV_ONLINE_DURATION_REQUIRED_MESSAGE,
        });
    }
}
export const RdvServiceOnlineConfigSchema = z
    .object({
    onlineBookingEnabled: z.boolean(),
    onlineDurationMinutes: z.number().int().positive().max(MAX_ONLINE_DURATION_MINUTES).nullable(),
})
    .superRefine(refineRdvOnlineDuration);
//# sourceMappingURL=service.types.js.map